import { action } from '@ember/object';

import type { PopupData } from 'webapp-types';

import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

export default class CommonPopupsPopupRadiobuttonListComponent extends PopupInnerContextComponent<PopupData.Common.RadiobuttonList> {
	get title() {
		return this.popupData.title;
	}

	get selected() {
		return this.popupData.selected;
	}

	get options() {
		return this.popupData.options;
	}

	@action
	handleChange(value: AnySimpleValue): void {
		this.popupData.onChange(value);
		this.close();
	}

	<template>
		<div class="title">{{this.title}}</div>
		<FormRadiobuttonGroupComponent
			class="radiobutton-default"
			@selected={{this.selected}}
			@options={{this.options}}
			@onChange={{this.handleChange}}
		/>
	</template>
}
